import React, { useState, useRef, useEffect } from "react";



export default function App({Treino, data, AddExecicio, Chave}) {

  const [open, setOpen] = useState(false);
  const [busca, setBusca] = useState("");
  const [selecionado, setSelecionado] = useState(Treino.Nome ? Treino : null);
  const containerRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtrados = data.filter(item =>
    item.Nome.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div style={{  }}>
     

      

      {/* Exibindo seleção */}
      {selecionado && (
        <div style={{ marginTop: 20 }}>

          <div >    
          <img
            src={selecionado.UrlTrenio}
            alt={selecionado.Nome}
            style={{ width: 200, height: 200, borderRadius:10 }}
          /><br/>
          <strong >Categoria:</strong><br/>
          <string style={{ marginBottom:1 }}>{selecionado.Categoria}</string><br/>
           <strong  >Exercício:</strong><br/>
          <string style={{ marginBottom:1 }}>{selecionado.Nome}</string><br/>
          </div>
        </div>
      )}
    </div>
  );
}
